export default __webpack_public_path__ + "static/przemek_pixel-e31b29656ebfded38fff38471458342d.png";